export enum AddTrailerFomNames {
	trailerReg = 'trailerReg',
	trailerType = 'trailerType',
	trailerCapacity = 'trailerCapacity',
}
